<template>
  <div class="h-full w-full mt-5 text-left flex flex-col">
    <label
      :for="id"
      class="w-full text-xs md:text-xs text-gray-500 text-opacity-80"
      :class="{ 'text-red-500': invalid }"
      ><b>{{ label }}</b
      ><span v-if="required" class="text-red-500">*</span>
      <p v-if="maxlength" class="text-xs text-gray-400">
        (Máximo {{ maxlength }} carácteres)
      </p></label
    >
    <textarea
      class="w-full mt-2 border rounded-lg text-xs md:text-sm resize-none"
      :class="classObject"
      :name="id"
      :placeholder="placeholder"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @keyup="checkInput"
      :maxlength="maxlength"
      rows="6"
      :disabled="disabled"
    ></textarea>
    <p v-if="invalid" class="mt-2 text-xs text-red-500">
      Este campo es obligatorio
    </p>
  </div>
</template>

<script>
export default {
  props: [
    'id',
    'type',
    'label',
    'placeholder',
    'value',
    'disabled',
    'danger',
    'required',
    'maxlength',
  ],
  data() {
    return {
      invalid: false,
    }
  },
  methods: {
    checkInput() {
      if (this.value == '' && this.required) {
        this.invalid = true
        this.feedback = 'Este campo es obligatorio'
      } else {
        this.invalid = false
        this.feedback = ''
      }
    },
    setInvalid(invalid) {
      if (this.required) {
        this.invalid = invalid
      }
    },
  },
  computed: {
    classObject: function () {
      let classes = ['border-gray-300', 'placeholder-gray-400']
      if (this.danger || this.invalid) {
        classes = ['border-red-500', 'placeholder-red-500']
      }
      return classes
    },
  },
}
</script>

<style></style>
